// src/components/common/Drawer.jsx
import { Drawer } from "@mui/material";
import { Fragment, useEffect } from "react";
import { useStaticImages } from "../../hooks/useStaticImages";

export const DrawerComponent = ({
  id,
  children,
  open = false,
  setOpen,
  anchor = "top",
  headerText = "",
  height = "100%"
}) => {
  // Reset scroll position when drawer opens
  useEffect(() => {
    if (open) {
      // Small delay to ensure drawer is rendered
      setTimeout(() => {
        const drawerContent = document.querySelector(`[data-drawer-id="${id}"]`);
        if (drawerContent) {
          drawerContent.scrollTop = 0;
        }
      }, 100);
    }
  }, [open, id]);

  return (
    <Fragment>
      <Drawer
        anchor={anchor}
        open={open}
        PaperProps={{
          sx: {
            height,
            minWidth: anchor === "right" ? "70%" : "100%",
            overflowY: "auto",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
            "&::-webkit-scrollbar": {
              display: "none" // Hide scrollbar on mobile
            },
            msOverflowStyle: "none", // Hide scrollbar on IE/Edge
            scrollbarWidth: "none", // Hide scrollbar on Firefox
          },
        }}
      >
        <div data-drawer-id={id} style={{ height: "100%", overflowY: "auto" }}>
          <DrawerHeader headerText={headerText} setOpen={setOpen} />
          <div style={{ 
            padding: "16px",
            height: "calc(100% - 83px)", // 83px is header height
            overflowY: "auto",
            WebkitOverflowScrolling: "touch"
          }}>
            {children}
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
};

const DrawerHeader = ({ headerText, setOpen }) => {
  const { cancel } = useStaticImages();
  return (
    <div
      className="flex-row justify-content-space-between align-items-center"
      style={{
        width: "100%",
        backgroundColor: "#003663",
        padding: "29px 28px",
        position: "sticky",
        top: 0,
        zIndex: 1,
      }}
    >
      <h5 className="text-white mb-0">{headerText}</h5>
      <span
        style={{ color: "white", cursor: "pointer" }}
        onClick={() => setOpen(false)}
      >
        <img
          srcSet={cancel}
          alt="close"
          style={{ maxHeight: "25px" }}
        />
      </span>
    </div>
  );
};
